<template>
    <div>
        <custom-modal dir="right" modalName="promo">
            <template #header>
                <h4 class="modal-title" id="myModalLabel1">Créer une categorie d'intermediaire</h4>
            </template>
            <template #body>
                <div class="row">
                    <div class="col-md-12">
                        <div class="form-group">
                            <label>Categorie d'intermediaire</label>
                            <input v-model="form.name" type="text" class="form-control">
                            <div v-if="errors.name" style="color: red">{{ errors.name[0] }}</div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-12">
                        <button type="button" :class="loading ? 'disabled' : ''" @click.prevent="addNewCategorieIntermediaire()" class="btn btn-primary">Ajouter</button>
                        <button type="button" class="btn btn-light" data-dismiss="modal">Annuler</button>
                    </div>
                </div>
            </template>
        </custom-modal>

        <custom-modal dir="right" modalName="promoAlter">
            <template #header>
                <h4 class="modal-title" id="myModalLabel1">Modifier la categorie d'intermediaire</h4>
            </template>
            <template #body>
                <div class="row">
                    <div class="col-md-12">
                        <div class="form-group">
                            <label>Categorie d'intermediaire</label>
                            <input v-model="form.name" type="text" class="form-control">
                            <div v-if="errors.name" style="color: red">{{ errors.name[0] }}</div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <button type="button" :class="loading ? 'disabled' : ''" @click.prevent="updateCategorieIntermediaire()" class="btn btn-primary"> Modifier</button>
                        <button type="button" class="btn btn-light" data-dismiss="modal">Annuler</button>
                    </div>
                </div>
            </template>
        </custom-modal>

        <div class="content-header row">
            <div class="content-header-left col-md-9 col-12 mb-2">
                <div class="row breadcrumbs-top">
                    <div class="col-12">
                        <h2 class="content-header-title float-left mb-0">Categorie d'intermediaire</h2>
                    </div>
                </div>
            </div>
        </div>
        <div class="content-body">
            <div class="row">
                <div class="col-12">
                    <div class="card">
                        <div class="card-body">
                            <div class="d-flex justify-content-between align-items-center row">
                                <div class="col-sm-1 col-md-1">
                                    <select style="width:60px !important" class="form-control" v-model="tableData.length" @change="changePerPage()">
                                        <option v-for="(records, index) in perPage" :key="index" :value="records">{{records}}</option>
                                    </select>
                                </div>
                                <div id="search_zone" class="mb-2 mr-1 text-right">
                                    <input class="form-control" type="text" v-model="tableData.search"
                                    @input="getSearch()">
                                    <button @click="showModal()" class="btn btn-primary">Créer une categorie d'intermediaire</button>
                                </div>
                            </div>
                            <v-table :columns="columns" :sortKey="sortKey" :sortOrders="sortOrders" @sort="sortBy">
                                <tbody>
                                    <tr v-for="(item, key) in promotions" :key="key">
                                        <td>{{ item.name }}</td>
                                        <td>
                                            <div>
                                                <a title="Modifier" @click.prevent="showEdit(item,key)">
                                                    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M2.5 3.25C2.30109 3.25 2.11032 3.32902 1.96967 3.46967C1.82902 3.61032 1.75 3.80109 1.75 4V14.5C1.75 14.6989 1.82902 14.8897 1.96967 15.0303C2.11032 15.171 2.30109 15.25 2.5 15.25H13C13.1989 15.25 13.3897 15.171 13.5303 15.0303C13.671 14.8897 13.75 14.6989 13.75 14.5V10.495C13.75 10.0808 14.0858 9.745 14.5 9.745C14.9142 9.745 15.25 10.0808 15.25 10.495V14.5C15.25 15.0967 15.0129 15.669 14.591 16.091C14.169 16.5129 13.5967 16.75 13 16.75H2.5C1.90326 16.75 1.33097 16.5129 0.90901 16.091C0.487053 15.669 0.25 15.0967 0.25 14.5V4C0.25 3.40326 0.487053 2.83097 0.90901 2.40901C1.33097 1.98705 1.90326 1.75 2.5 1.75H6.505C6.91921 1.75 7.255 2.08579 7.255 2.5C7.255 2.91421 6.91921 3.25 6.505 3.25H2.5Z" fill="#6E6B7B"/>
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M12.4697 0.46967C12.7626 0.176777 13.2374 0.176777 13.5303 0.46967L16.5303 3.46967C16.8232 3.76256 16.8232 4.23744 16.5303 4.53033L9.03033 12.0303C8.88968 12.171 8.69891 12.25 8.5 12.25H5.5C5.08579 12.25 4.75 11.9142 4.75 11.5V8.5C4.75 8.30109 4.82902 8.11032 4.96967 7.96967L12.4697 0.46967ZM6.25 8.81066V10.75H8.18934L14.9393 4L13 2.06066L6.25 8.81066Z" fill="#6E6B7B"/>
                                                    </svg>
                                                </a>
                                                <a title="Supprimer" @click.prevent="removeCategorieIntermediaire(item)">
                                                    <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M2 5C2 4.58579 2.33579 4.25 2.75 4.25H16.25C16.6642 4.25 17 4.58579 17 5C17 5.41421 16.6642 5.75 16.25 5.75H2.75C2.33579 5.75 2 5.41421 2 5Z" fill="#6E6B7B"/>
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M8 2.75C7.80109 2.75 7.61032 2.82902 7.46967 2.96967C7.32902 3.11032 7.25 3.30109 7.25 3.5V4.25H11.75V3.5C11.75 3.30109 11.671 3.11032 11.5303 2.96967C11.3897 2.82902 11.1989 2.75 11 2.75H8ZM13.25 4.25V3.5C13.25 2.90326 13.0129 2.33097 12.591 1.90901C12.169 1.48705 11.5967 1.25 11 1.25H8C7.40326 1.25 6.83097 1.48705 6.40901 1.90901C5.98705 2.33097 5.75 2.90326 5.75 3.5V4.25H4.25C3.83579 4.25 3.5 4.58579 3.5 5V15.5C3.5 16.0967 3.73705 16.669 4.15901 17.091C4.58097 17.5129 5.15326 17.75 5.75 17.75H13.25C13.8467 17.75 14.419 17.5129 14.841 17.091C15.2629 16.669 15.5 16.0967 15.5 15.5V5C15.5 4.58579 15.1642 4.25 14.75 4.25H13.25ZM5 5.75V15.5C5 15.6989 5.07902 15.8897 5.21967 16.0303C5.36032 16.171 5.55109 16.25 5.75 16.25H13.25C13.4489 16.25 13.6397 16.171 13.7803 16.0303C13.921 15.8897 14 15.6989 14 15.5V5.75H5Z" fill="#6E6B7B"/>
                                                    </svg>
                                                </a>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </v-table>
                            <v-paginate :links="links" :navigationFunction="navigation"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {api, _buildQuery, scheme } from "../../../helpers/shared";
    import vTable from '../../../components/vTable/vTable.vue';
    import vPaginate from '../../../components/vTable/vPaginate1.vue';
    import customModal from '../../../components/modal/customModal.vue';
    import axios from 'axios';
    import  debounce  from 'lodash/debounce';
    const default_data = {
        first_name: '',
        last_name: '',
        email: '',
        phone: '',
        profile: ''
    };
    var $this;
    export default {
        name: "index",
        components:{
            vTable, vPaginate, customModal
        },
        props: ['self'],
        data() {
            let sortOrders = {};
            let columns = [
                {width: '33%', label: 'Categorie Intermediaire', name: 'name' },
                {width: '33%', label: 'Actions', name: 'status'},
            ];
            columns.forEach((column) => {
                sortOrders[column.name] = -1;
            });
            return {
                links: [],
                promotions: [],
                columns: columns,
                sortKey: 'customer',
                sortOrders: sortOrders,
                perPage: ['10', '20', '30'],
                tableData: {
                    page: 0,
                    length: 10,
                    search: '',
                    column: 0,
                    dir: 'desc',
                },
                form:{
                    name: '',
                },
                errors: [],
                loading: false,
                index: null,
            }
        },
        created(){
            $this = this
        },
        mounted(){
            this.getCategorieIntermediaire();
        },
        methods:{
            changeRole(){
                this.changePerPage();
            },
            changePerPage(url = 'administration/categorie-intermediare/list'){
                this.tableData.page = 1;
                axios.get(api(url), {params: this.tableData})
                .then(response => {
                    let content = response.data;
                    this.promotions = content.data;
                    this.configPagination(content);
                })
                .catch(errors => {
                    console.log(errors);
                });
            },
            getNext(url){
                this.tableData.page ++;
                axios.get(url, {params: this.tableData})
                .then(response => {
                    let content = response.data;
                    this.promotions = content.data;
                    this.configPagination(content);
                })
                .catch(errors => {
                    console.log(errors);
                });
            },
            getPrev(url){
                this.tableData.page --;
                axios.get(url, {params: this.tableData})
                .then(response => {
                    let content = response.data;
                    this.promotions = content.data;
                    this.configPagination(content);
                })
                .catch(errors => {
                    console.log(errors);
                });
            },
            getCategorieIntermediaire(url = 'administration/categorie-intermediare/list') {
                let loader = this.$loading.show({
                    container: null,
                    canCancel: false,
                    color: "#4B4B4B",
                    backgroundColor: "#4B4B4B",
                    height: 35,
                    width: 35,
                    loader: "bars",
                    opacity: 0.3,
                });
                this.tableData.page++;
                axios.get(api(url), {params: this.tableData})
                    .then(response => {
                        loader.hide();
                        let content = response.data;
                        this.promotions = content.data;
                        this.configPagination(content);
                    })
                    .catch(errors => {
                        console.log(errors);
                    });
            },
            configPagination(data) {
                this.links = data.links;
            },
            sortBy(key) {
                this.sortKey = key;
                this.sortOrders[key] = this.sortOrders[key] * -1;
                this.tableData.column = this.getIndex(this.columns, 'name', key);
                this.tableData.dir = this.sortOrders[key] === 1 ? 'asc' : 'desc';
                this.getCategorieIntermediaire();
            },
            getIndex(array, key, value) {
                return array.findIndex(i => i[key] == value)
            },
            getSearch: debounce(function (e) {
                this.changePerPage()
            }, 500),

            addNewCategorieIntermediaire(){
                this.loading = true;
                axios.post(api('administration/categorie-intermediaire/create'), this.form).then((response) => {
                    this.loading = false;
                    this.errors = [];
                    if (response.data.status){
                        this.errors = [];
                        this.form = { ...default_data }
                        this.promotions.unshift(response.data.model);
                        this.$document('#promo').modal('hide');
                    }
                }).catch((error) => {
                    this.loading = false;
                    if (error.response.status === 401){
                    }else {
                        this.errors = error.response.data.errors;
                    }
                })
            },

            updateCategorieIntermediaire(){
                this.loading = true;
                axios.post(api('administration/categorie-intermediaire/update'), this.form).then((response) => {
                    this.loading = false;
                    this.errors = [];
                    if (response.data.status){
                        this.errors = [];
                        this.form = { ...default_data }
                        this.$document('#promoAlter').modal('hide');
                        this.promotions.splice(this.index, 1, response.data.model);
                        this.$toasted.global.all({message: 'Mise à jour éffecuté'});
                    }
                }).catch((error) => {
                    this.loading = false;
                    if (error.response.status === 401){
                        this.$toasted.global.error({message: "Votre connexion a expiré"});
                    }else {
                        this.errors = error.response.data.errors;
                    }
                })
            },

            showEdit(element,index){
                this.errors = [];
                this.form = { ...element }
                this.index = index;
                this.$document('#promoAlter').modal('show');
            },

            showModal(){
                this.errors = [];
                this.form = { ...default_data }
                this.$document('#promo').modal('show')
            },

            removeCategorieIntermediaire(element){
                $this.$swal.fire({
                    title: 'Êtes-vous sûr de vouloir supprimer cette categorie d\'intermediaire ?',
                    text: "Cette action est irréversible",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Oui, supprimer',
                    cancelButtonText: 'Annuler',
                    customClass: {
                    confirmButton: 'btn btn-primary',
                    cancelButton: 'btn btn-outline-danger ml-1'
                    },
                    buttonsStyling: false
                }).then(function (result) {
                    if (result.value) {
                        axios.post(api('administration/categorie-intermediaire/delete'), {id: element.id}).then(() => {
                            var index = $this.promotions.indexOf(element);
                            $this.promotions.splice(index, 1);
                            $this.$swal.fire({
                                icon: 'success',
                                title: 'Opération réussie!',
                                text: 'Cette categorie d\'intermediaire a été supprimée.',
                                customClass: {
                                confirmButton: 'btn btn-success'
                                }
                            });
                        }).catch((error) => {
                            this.loadingData = false;
                            if (error.response.status === 401){
                                this.$toast.global.error({message: "Votre connexion a expiré"});
                            }else {
                            }
                        })
                    }
                });
            },
            navigation(page) {
                this.tableData.page = page;
                axios.get(api('administration/categorie-intermediare/list'), {params: this.tableData})
                    .then(response => {
                        let content = response.data;
                        this.promotions = content.data;
                        this.configPagination(content);
                    })
                    .catch(errors => {
                        console.log(errors);
                    });
            },
        }
    }
</script>

<style scoped>
    #search_zone{
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-gap: 5px;
    }
</style>
